import type { EmpresaRequest, EmpresaResponse } from '@/types/empresa.model';
import ApiClient from '@/services/api/axios/apiClient';

const EMPRESA_ENDPOINT = '/empresas';

/**
 * Creates a new empresa record
 * @param empresaData - The empresa data to create
 * @returns Promise containing the created empresa
 */
export const createEmpresa = async (
  empresaData: EmpresaRequest
): Promise<EmpresaResponse> => {
  try {
    const response = await ApiClient.post(`${EMPRESA_ENDPOINT}`, empresaData);
    return response.data;
  } catch (error) {
    console.error('Error creating empresa:', error);
    throw error;
  }
};

/**
 * Fetches an empresa by ID
 * @param id - The empresa ID
 * @returns Promise containing the empresa
 */
export const getEmpresaById = async (id: number): Promise<EmpresaResponse> => {
  try {
    const response = await ApiClient.get(`${EMPRESA_ENDPOINT}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching empresa:', error);
    throw error;
  }
};

/**
 * Updates an existing empresa
 * @param id - The empresa ID
 * @param empresaData - The updated empresa data
 * @returns Promise containing the updated empresa
 */
export const updateEmpresa = async (
  id: number,
  empresaData: Partial<EmpresaRequest>
): Promise<EmpresaResponse> => {
  try {
    const response = await ApiClient.put(`${EMPRESA_ENDPOINT}/${id}`, empresaData);
    return response.data;
  } catch (error) {
    console.error('Error updating empresa:', error);
    throw error;
  }
};

/**
 * Deletes an empresa by ID
 * @param id - The empresa ID
 * @returns Promise indicating success or failure
 */
export const deleteEmpresa = async (id: number): Promise<void> => {
  try {
    await ApiClient.delete(`${EMPRESA_ENDPOINT}/${id}`);
  } catch (error) {
    console.error('Error deleting empresa:', error);
    throw error;
  }
};

